import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { PointFeature } from '@models/point';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { NgImageSliderModule, NgImageSliderComponent } from 'ng-image-slider';

@Component({
  selector: 'app-point-detail',
  standalone: true,
  imports: [
    MatCardModule,
    CommonModule,
    NgImageSliderModule
  ],
  templateUrl: './point-detail.component.html',
  styleUrl: './point-detail.component.css'
})
export class PointDetailComponent implements OnInit, AfterViewInit {
  @Input() pt!: PointFeature;
  @ViewChild('slider') slider!: NgImageSliderComponent;
  primaryImage!: string;
  images: Object[] = [];
  imageSize = {width: '279px', height: '205px', space: 3}

  ngOnInit(): void {
    this.primaryImage = this.pt.images[0].name;
    this.pt.images.forEach(ele => {
      this.images.push({
        image: ele.name,
        thumbImage: ele.name,
        alt: ele.altText,
        title: ele.description
      });
    });
  }

  ngAfterViewInit(): void {
    this.slider.setSliderWidth();
  }
}
